// extracted by mini-css-extract-plugin
module.exports = {"title":"_6c97079b1b--title--bkHQj","description":"_6c97079b1b--description--22Y8u","img":"_6c97079b1b--img--27nZh"};